export const RowDragHandleColumnId = 'row-drag-handle'
export const RowExpandColumnId = 'row-expand'
export const AddColumnId = 'add-column'
export const RoadmapPillAreaColumnId = 'roadmap-pill-area'

/** Check whether a column id is for the leading "row handle" field on the table */
export const isDragDropColumnId = (columnId: string): boolean => {
  return columnId === RowDragHandleColumnId
}

/** Check whether this column id is for the trailing "add column" field on the table */
export const isAddColumnId = (columnId: string): boolean => {
  return columnId === AddColumnId
}

/** Check whether this column id is for the trailing "roadmap pill area" field in the Roadmap view */
export const isRoadmapPillAreaColumnId = (columnId: string): boolean => {
  return columnId === RoadmapPillAreaColumnId
}
